import { createTheme } from "@mui/material"

const theme = createTheme({
    shape: {
        borderRadius: 8
    },
    palette: {
        mode: "light",
        primary: {
            main: "#F05125",
            contrastText: "#F5F5F5"
        },
        background: {
            default: "#F0F0F0",
            paper: "#F5F5F5"
        }
    },
    typography: {
        fontFamily: "\"Inter Variable\", sans-serif"
    },
    components: {
        MuiAccordion: {
            defaultProps: {
                variant: "outlined"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                size: "small"
            }
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                size: "small",
                variant: "contained"
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiCard: {
            defaultProps: {
                variant: "outlined"
            }
        },
        MuiCheckbox: {
            defaultProps: {
                size: "small"
            }
        },
        MuiChip: {
            defaultProps: {
                size: "small"
            }
        },
        MuiDataGrid: {
            defaultProps: {
                density: "compact"
            }
        },
        MuiFormControl: {
            defaultProps: {
                size: "small"
            }
        },
        MuiIconButton: {
            defaultProps: {
                size: "small"
            }
        },
        MuiPagination: {
            defaultProps: {
                size: "small"
            }
        },
        MuiSelect: {
            defaultProps: {
                size: "small"
            }
        },
        MuiSwitch: {
            defaultProps: {
                size: "small"
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    alignContent: "center"
                }
            }
        },
        MuiTabPanel: {
            styleOverrides: {
                root: {
                    padding: 0,
                    paddingTop: 20
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                size: "small",
                variant: "outlined"
            }
        }
    }
})

export default theme
